import styled from 'styled-components'
import { flexBox, fontSize } from '../../shared/styles/mixins'

export const FaqWrapper = styled.section`
  display: flex;
  flex-flow: row wrap;
  @media(max-width: 989px) {
    justify-content: center;
  }
`

export const Content = styled.section`
  ${flexBox('column')};
  padding-bottom: 0;
  padding-top: 0;
  background: transparent;
`;

export const SectionTitle = styled.h2`
  ${fontSize(16)};
  font-weight: 300;
  letter-spacing: normal;
  color: #505050;
  align-self: flex-start;
  padding: 41px 0 32px;
  border-top: 1px solid #C6D2EC;
  width: 100%;
`